<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { definePage } from "unplugin-vue-router/runtime";
import Loading from "@/components/shared/Loading.vue";
import MyDsosTable from "@/components/models/practice/table/MyDsosTable.vue";
import { useCanAccessOfficesManagement } from "@/composables/shared/useSectionPermissions";
import { useOrganizationLevel } from "@/composables/shared/useMyOrganization";

definePage({
  meta: {
    title: "generic.entity.dso",
    checkPrivileges: () => useCanAccessOfficesManagement().value,
  },
});

const { t } = useI18n();
const { msosQuery, isList, isEmpty } = useOrganizationLevel("dso");
</script>

<template>
  <div class="tw:py-4! tw:sm:py-6!">
    <div
      v-if="isEmpty"
      class="tw:text-center tw:text-sm tw:text-on-surface/50 tw:py-16!"
    >
      {{ t("generic.messages.noEntity", { entity: t("generic.entity.dso") }) }}
    </div>

    <Loading
      v-else-if="!isList"
      :size="32"
      class="tw:my-6!"
    />

    <my-dsos-table
      v-else
      :query="msosQuery"
    />
  </div>
</template>
